// extracted by mini-css-extract-plugin
export default {"paginatorContainer":"Paginator_paginatorContainer__wmMld","showPerPage":"Paginator_showPerPage__LORZy","nameShowPerPage":"Paginator_nameShowPerPage__759Um"};